import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/ourdoctors',
        name: 'Наши Врачи',
        originalName: 'Наши Врачи',
        component: () => import('../views/Doctors.vue')
    },
    {
        path: '/contact',
        name: 'Контакты',
        component: () => import('../views/Contact.vue')
    },
    {
        path: '/blog/:title',
        name: 'articleDetail',
        component: () => import('../views/ArticleDetail')
    },
    {
        path: '/offer/:title',
        name: 'offerDetail',
        component: () => import('../views/ArticleDetail')
    },
    {
        path: '/special-programs/:title',
        name: 'specialPrograms',
        component: () => import('../views/ArticleDetail')
    },
    {
        path: '/blog',
        name: 'Новости',
        component: () => import('../views/Blog')
    },
    {
        path: '/акции',
        name: 'Акции',
        component: () => import('../views/Promotios')
    },
    {
        path: '/услуги-и-цены',
        name: 'Прейскурант',
        component: () => import('../views/ServicesAndPrices')
    },
    {
        path: '/направления-tst',
        name: 'Услуги',
        component: () => import('../views/Departments')
    },
    {
        path: '/расписание',
        name: 'Расписание',
        component: () => import('../views/TimeTable')
    },
    {
        path: '/направления-tst/:slug',
        name: 'departmentDetail',
        component: () => import('../views/DepartmentDetail')
    },
    {
        path: '/партнерам/программы-медицинского-обслуживания',
        name: 'Программы медицинского обслуживания',
        component: () => import('../views/staticPages/medicalPrograms')
    },
    {
        path: '/партнерам/стерилизация-медицинских-изделий',
        name: 'Стерилизация медицинских изделий',
        component: () => import('../views/staticPages/sterilization')
    },
    {
        path: '/высокотехнологичная-медицинская-пом',
        name: 'Высокотехнологичная медицинская помощь',
        component: () => import('../views/staticPages/highMedicalTechnology')
    },
    {
        path: '/пациентам/сотрудничество-со-страховыми-компан',
        name: 'Сотрудничество со страховыми компаниями',
        component: () => import('../views/staticPages/insurance')
    },
    {
        path: '/home/регистрационные-документы-поликлини',
        name: 'Регистрационные документы поликлиники',
        component: () => import('../views/staticPages/registrationDocuments')
    },
    {
        path: '/home/вакансии',
        name: 'Вакансии',
        component: () => import('../views/staticPages/applications')
    },
    {
        path: '/home/противодействие-коррупции',
        name: 'Противодействие коррупции',
        component: () => import('../views/staticPages/corruption')
    },
    {
        path: '/документы',
        name: 'Документы',
        component: () => import('../views/staticPages/documents')
    },
    {
        path: '/home/руководство-поликлиники',
        name: 'Руководство поликлиники',
        component: () => import('../views/staticPages/leadership')
    },
    {
        path: '/home/история-поликлиники',
        name: 'История поликлиники',
        component: () => import('../views/staticPages/history')
    },
    {
        path: '/home/о-поликлинике',
        name: 'О поликлинике',
        component: () => import('../views/staticPages/about')
    },
    {
        path: '/пациентам/подготовка-к-исследованиям',
        name: 'Подготовка к исследованиям',
        component: () => import('../views/staticPages/preparation')
    },
    {
        path: '/пациентам/страничка-психотерапевта',
        name: 'Страничка психотерапевта',
        component: () => import('../views/staticPages/psychotherapy')
    },
    {
        path: '/пациентам/страничка-офтальмолога',
        name: 'Страничка офтальмолога',
        component: () => import('../views/staticPages/ophthalmology')
    },
    {
        path: '/пациентам/оформление-справок',
        name: 'Оформление справок',
        component: () => import('../views/staticPages/registration')
    },
    {
        path: '/партнерам/медицинские-осмотры-по-приказу-29н',
        name: 'Медицинские осмотры по приказу 29н',
        component: () => import('../views/staticPages/examinations')
    },
    {
        path: '/ourdoctors/научные-работы/',
        name: 'Научные работы наших врачей',
        component: () => import('../views/staticPages/medicalResearch')
    },
    {
        path: '/урсодезоксихолевая-кислота-в-гастро/',
        name: 'Урсодезоксихолевая кислота в гастроэнтерологической практике',
        component: () => import('../views/staticPages/research1')
    },
    {
        path: '/ингибиторы-протонной-помпы-в-терапии/',
        name: 'Ингибиторы протонной помпы в терапии кислотозависимых заболеваний',
        component: () => import('../views/staticPages/research2')
    },
    {
        path: '/обследование-на-helicobacter-pylori/',
        name: 'Обследование на Helicobacter pylori',
        component: () => import('../views/staticPages/pylori')
    },
    {
        path: '/рентгенологические-исследования/',
        name: 'Рентгенологические исследования',
        component: () => import('../views/staticPages/rads')
    },
    {
        path: '/эгдс-исследования/',
        name: 'ЭГДС исследования',
        component: () => import('../views/staticPages/EGDC')
    },
    {
        path: '/ультразвуковые-исследования/',
        name: 'Ультразвуковые исследования',
        component: () => import('../views/staticPages/ultraSound')
    },
    {
        path: '/функциональная-диагностика/',
        name: 'Функциональная диагностика',
        component: () => import('../views/staticPages/functionalDiagnostics')
    },
    {
        path: '/rentgen-mlechnikh-protokov/',
        name: 'Подготовка к рентгенологическому исследованию млечных протоков',
        component: () => import('../views/staticPages/prepForRads')
    },
    {
        path: '/лабораторные-исследования/',
        name: 'Лабораторные исследования',
        component: () => import('../views/staticPages/labResearch')
    },
    {
        path: '/утро-вечера-мудренее/',
        name: 'Утро Вечера Мудренее',
        component: () => import('../views/staticPages/dayNight')
    },
    {
        path: '/учиться-радоваться-жизни/',
        name: 'Учиться радоваться жизние',
        component: () => import('../views/staticPages/learnHappy')
    },
    {
        path: '/нарушения-пищевого-поведения/',
        name: 'Нарушения пищевого поведения',
        component: () => import('../views/staticPages/happyDiet')
    },
    {
        path: '/психосоматические-расстройства/',
        name: 'Психосоматические расстройства, как реакция на психосоциальный стресс',
        component: () => import('../views/staticPages/psycho')
    },
    {
        path: '/пациентам/программы/специальные-программы/',
        name: 'Специальные программы',
        component: () => import('../views/staticPages/specPrograms')
    },
    {
        path: '/пациентам/правила-и-сроки-госпитализации/',
        name: 'Правила и сроки госпитализации',
        component: () => import('../views/staticPages/hospitalityRules')
    },
    {
        path: '/пациентам/программы/программы-годового-обслуживания/',
        name: 'Программы годового обслуживания',
        component: () => import('../views/staticPages/yearPrograms')
    },
    {
        path: '/vedenie-beremennosti/',
        name: 'Ведение беременности',
        component: () => import('../views/staticPages/pregnancy')
    },
    {
        path: '/пациентам/информация-для-пациентов/',
        name: 'Информация для пациентов',
        component: () => import('../views/staticPages/patientInfo')
    },

    //@desc patients category->registration of certificates static pages
    {
        path: '/санаторно-курортная-карта',
        name: 'Санаторно курортная карта',
        component: () => import("../views/staticPages/Patients-static-pages/resort")
    },
    {
        path: '/предварительные-медицинские-осмотры',
        name: 'Предварительные медосмотры',
        component: () => import("../views/staticPages/Patients-static-pages/examinations")
    },
    {
        path: '/медицинские-осмотры-для-абитуриенто',
        name: 'Медосмотры абитуриентов',
        component: () => import("../views/staticPages/Patients-static-pages/medicalExams")
    },
    {
        path: '/медицинская-водительская-комиссия',
        name: 'Для водителей',
        component: () => import("../views/staticPages/Patients-static-pages/drivingLicence")
    },
    {
        path: '/справка-в-бассейн',
        name: 'Справка в бассейн',
        component: () => import("../views/staticPages/Patients-static-pages/poolLicence")
    },
    {
        path: '/освидетельствование-на-должность-су',
        name: 'Освидетельствование на должность судьи',
        component: () => import("../views/staticPages/Patients-static-pages/judgeLicence")
    },
    {
        path: '/гостайн',
        name: 'Справка на гостайну',
        component: () => import("../views/staticPages/Patients-static-pages/guestine")
    },
    {
        path: '/справка-для-поступающих-на-государст',
        name: 'Справка для поступающих на государственнуф службу',
        component: () => import("../views/staticPages/Patients-static-pages/publicService")
    },
    {
        path: '/пациентам/программы/постковидные-программы',
        name: 'Постковидные программы',
        component: () => import("../views/staticPages/covidPrograms")
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
